module.exports = __webpack_public_path__ + "static/media/file-folder.324d5c02.svg";